module.exports = __webpack_public_path__ + "30787e338b319fb79e73849fafb1766b.MP3";